<template>
  <b-modal ref="authModal" centered hide-footer title="تسجيل الدخول">
    <div id="firebaseui-auth-container"></div>
  </b-modal>
</template>

<script>
import { auth, getFirebaseUsersInLocalStorage } from './firebase.js'

import { GoogleAuthProvider, EmailAuthProvider, PhoneAuthProvider, setPersistence, browserLocalPersistence, signInAnonymously } from 'firebase/auth'
import * as firebaseui from 'firebaseui/dist/npm__ar'
import 'firebaseui/dist/firebaseui-rtl.css'

export default {
  name: 'FirebaseAuthWrapper',
  props: {
  },
  computed: {
  },
  components: {
  },
  methods: {
    show: function () {
      this.ui.reset()
      this.ui.start('#firebaseui-auth-container', this.uiConfig)
      this.$refs.authModal.show()
    },
    hide: function () { this.$refs.authModal.hide() },
    _signInSuccessWithAuthResult: function (authResult, redirectUrl) {
      this.hide()
      const u = authResult.user
      console.log(`Signed in: ${u.displayName}, email ${u.email} / phone ${u.phoneNumber}, via ${u.providerId}, ${u.uid}`)
      this.$store.commit('updateUser', u)
      return false // Do not redirect
    }
  },
  created: function () {
    setPersistence(auth, browserLocalPersistence).then(() => {
      console.log('Local storage user info', getFirebaseUsersInLocalStorage())
      if (getFirebaseUsersInLocalStorage().length == 0) {
        signInAnonymously(auth)
      }
    })

    // There should be a better place for this config, right?
    this.uiConfig = {
      signInSuccessUrl: '<url-to-redirect-to-on-success>',
      signInFlow: 'popup',
      callbacks: {
        signInSuccessWithAuthResult: this._signInSuccessWithAuthResult
      },
      signInOptions: [
        GoogleAuthProvider.PROVIDER_ID,
        {
          provider: EmailAuthProvider.PROVIDER_ID,
          requireDisplayName: true
        },
        PhoneAuthProvider.PROVIDER_ID
      ],
      tosUrl: 'http://www.muraija.org/staging/#/static/privacy_policy.html/ltr',
      privacyPolicyUrl: 'http://www.muraija.org/staging/#/static/privacy_policy.html/ltr',
      credentialHelper: firebaseui.auth.CredentialHelper.NONE
    }
    this.ui = new firebaseui.auth.AuthUI(auth)
  }
}
</script>

<style scoped></style>
